// extracted by mini-css-extract-plugin
module.exports = {"rounded-image-with-fallback":"styles_rounded-image-with-fallback__2LTpj"};